module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"login":"Login"},"fr":{"login":"Se connecter"}}')
  delete Component.options._Ctor
}
